import proj4 from "proj4";
export class Positions {
    constructor(positions, crs) {
        this.positions = positions;
        this.crs = crs;
    }
    inCrs(v) {
        return this.crs === v;
    }
    project(toCrs) {
        if (this.inCrs(toCrs)) {
            return this.copy();
        }
        else {
            const projectedPolygon = this.positions.map(([lng, lat]) => proj4(this.crs, toCrs, [lng, lat]));
            return new Positions(projectedPolygon, toCrs);
        }
    }
    toTransferable() {
        return {
            crs: this.crs,
            positions: this.positions,
        };
    }
    copy() {
        return new Positions(this.positions, this.crs);
    }
    static fromTransferable({ positions, crs, }) {
        return new Positions(positions, crs);
    }
}
//# sourceMappingURL=Positions.js.map